import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import { FIREBASE_CONFIG } from '../environments/firebase-config';

if (firebase.apps.length === 0) firebase.initializeApp(FIREBASE_CONFIG);

const db = firebase.firestore();
// db.settings({ host: 'localhost:8100', ssl: false });
// firebase.functions().useFunctionsEmulator('http://localhost:50001');

export const usersCollection = db.collection('supermarkets');
export const plansCollection = db.collection('plansConfig');
export const pickersCollection = db.collection('pickers');
export const masterCollection = db.collection('admin');
export const redesCollection = db.collection('redes');
export const chainsCollection = db.collection('supermarketChains');